<template>
  <div id="reportDetail">
		<buyPlan  ref="edit" />
		<plugin />
<!-- <div class='reportBox'>
    <div class='kong' >
        <div class='box'>
              <div class="report">
                  <div class='reportTitle'>
                        <div class='reportTitleBox'>
                            <div class='reportTitleLeft'>
                                <div class="date">{{reportInfo.create_date}}</div>
                            </div>
                            <div class='reportTitleRight'>
                          
                            </div>
                        </div>
                  </div>
                  <div class='reportCenter'>
                        <div class='reportCenterBox'>
                        <div class='reportCenterTop'>
                              <div class='reportCenterTopImg'>
                                                             </div>
                              <div class='reportCenterTopTxt'>
                                  <div class='reportCenterTopTxtName'>Cori Cohen</div>
                                  <div class='reportCenterTopTxtDr'>美国注册营养师 RDN</div>
                              </div>
                        </div>
                        <div class='reportCenterBottom'><span>太棒了！健康的作息和良好的身体状态，让生活变得更加积极，你暂时不需要膳食营养补充剂，请继续保持良好的习惯吧。</span>
                            <img src='../assets/talksanjiao.png'></img>
                        </div>
                        </div>
                  </div>
              </div>
        </div>
    </div>
</div> -->
    

<div style='height:0.4rem;'></div> 
	<swiper  ref="mySwiper"  class='swiper' :options="swiperOption" >

    <swiper-slide class='swiperitem'>
    	 <div class='box'>            
                <div class="report">
                    <div class='reportTitle'>
                          <div class='reportTitleBox'>
                              <div class='reportTitleLeft'>
                                  <div class="date">{{reportInfo.create_date}}</div>
                                        <div class="name">Hello {{reportInfo.fill_name}}</div>
                              </div>
                              <div class='reportTitleRight'>
								  <span  v-if='reportInfo.head=="../assets/tab-bar/indexme.png"' style='position: relative;top:0.09rem'></span>
								  <img :src='reportInfo.head' v-else></img>
								  
                                  
                              </div>
                          </div>
                    </div>
    
 
    
          <div class='reportContent'>
              <div class='reportContentBox'>
                  <div class="text">我的健康目标</div>
                        <div class="tags">
                            <div v-for='item in reportInfo.re_cate' >
                                <img :src="item.thumb_url" />
                                <div>{{item.title}}</div>
                            </div>
                        </div>
              </div>
          </div>
          <div class="attrs">
              <div class="item">
                  <div>{{reportInfo.goods_count}}种</div>
                  <div>每天</div>
              </div>
              <div style='width:0.03rem;' >
                    <div style='background:rgba(80, 80, 80,0.15);0.03rem;height:1rem;position: relative;top:8vh;margin-top:-0.5rem;'></div>
              </div>
              <div class="item">
                  <div>{{reportInfo.goods_num}}颗</div>
                  <div>每袋</div>
              </div>
              <!-- <div class="item">
                  <div>￥{{reportInfo.month_price}}</div>
                  <div>每月</div>
              </div> -->
          </div>
              <div class='huadong'>
                    <span>左滑查看NUTRIPACKS根据你的<br/>
                    评估结果为你定制的营养补剂方案</span>
              </div>

          </div>
          </div>
        
     </swiper-slide>

      <swiper-slide class='swiperitem' v-for='item in products'>
          <div class='box'>

                  <div class='productImg'>
                      <div class='productImgBox'  :style="{backgroundImage: 'url(' + item.index_img + ')' }">
                        <div class='productImgTxt'>营养师推荐</div>
                      </div>
                 </div>
              
                  <div class='productcontTxt'>
                        <div class='productcontName'>{{item.goods_name}}</div>
                        <div  class='productcontImg'>
                             <img :src='itemImg.url'  v-for='itemImg in item.category' />
                        </div>
                  </div>

            <div class='productcontPage' :style="'height:' + teacherSay + 'px;'">
            
                  <div class='productcontUse'>推荐服用： 每日{{item.day_use}}颗</div>
                  <div class='productspec' >
                      <div v-for='itemspec in item.goods_spec'  class='itemspec' >{{itemspec}}</div>
                  </div>
                  <div class='productcontTeacher' v-if='item.reason&&item.reason.length>0'>
                          <div class='productcontTeacherBox'>
                              <div class='productcontTeacherImg'>
                                  <img :src='item.count_img' />
                              </div>
                              <div class='productcontTeacherName'>{{item.abbreviation}}</div>
                          </div>
                           <div class='sanjiao'>
                              <img src='../assets/sanjiao.png'></img>
                             </div>
                          <div class='productcontTeacherTxt' v-if='from=="friend"'>
                                 
                                     <div class='productcontTeacherTxt1' >隐私信息</div>
                                     <div class='productcontTeacherTxt2'>出于隐私考虑，我们不会透露好友的问卷信息，产品的推荐原因保密哦</div>

                          </div>
                          <div class='productcontTeacherTxt' v-if='from!="friend"'>

                                  <div  v-for='(itemTeason,index) in item.reason' >
                                      <div class='productcontTeacherTxt1' >{{itemTeason.re_title}}</div>
                                      <div class='productcontTeacherTxt2'>{{itemTeason.reason}}</div>               
                                      <div class='productcontTeacherTxt3' v-if='index!=item.reason.length-1'></div>
                                  </div>
                          </div>
                  </div> 
                  
            </div>
      
        
             <!-- <div class='toDeatil' >
                    <span>查看品质</span><img src='../assets/CombinedShape04191.png'></img> 
             </div> -->
 
          </div>
      </swiper-slide>

      <swiper-slide class='swiperitem' >
          <div class='box'>
                <div class='docterTitle'>营养师建议</div>
                <div class='docterCont'>
                    <img :src='reportInfo.proposal_img' ></img>
                </div>

          </div>
      </swiper-slide>
  </swiper>

            

              <div class="report-footer-bar-null">
				  
				  <!-- <div class="dots">
				        <div class="dot" :class="index==swiperCurrent ? 'active' : ''"  v-for="(item, index) in (products.length + 2)"></div>
				            
				  </div> -->
                          <!-- <div class="reBtn" bindtap="togetPaper" v-if='products.length>0'>获取纸质报告
                                <div class='btnTitle'>限时免费</div>
                          </div> -->
						  <div class="reBtn" @click="toBuy">直接购买</div>
                          <div class="whiteBtn" @click="addCart" v-if='products.length>0'>加入购物车</div>
                          <div class="whiteBtn" @click='toIndex' v-if='products.length<1'>返回首页</div>
                          
             </div>

			 <div class='cartDiv'>
				 <div class='cartNumBox' :class='cartNum>0?"cartBoxShow":""' @click='toCart'>
				 	  <img src='../assets/mealCart.png' class='cartNumImg'></image>
				 	  <div class='cartNum'>{{cartNum}}</div>
				 </div>
				 
			 </div>
			
                          
   </div>
  </div>
</template>

<script>



import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import buyPlan from '@/components/buyPlan.vue'
import plugin from '@/components/plugin.vue'
export default {
  name: 'report',
  components: {
      swiper,
    swiperSlide,
	buyPlan,
	plugin
  },
  data() {

	  const that = this
      return {
			   buyPlanShow:false, 
			   swiperOption:{
					centeredSlides:true,
					
					slidesPerdiv :'auto',
					spaceBetween:5,
					loop:false,
					speed:600, 
					centeredSlidesBounds: true,
					spaceBetween:30,
					on: {
							  slideChangeTransitionStart: function() {
									that.swiperCurrent = this.realIndex
							  },
						},
				},
			   reportInfo:{},
			   products:[],
			   swiperCurrent:0,
			   from:"me",
			   reportId:"",
			   cartNum:0,
	  }
	
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      },
     
    },
   
    beforeCreate:function() {
      this.reportId = this.$route.params.id
      if(!this.$route.params.id){
	   this.$router.replace({
			name: 'report'
		})
		// this.$router.go(-1)
      }
   
    },
    mounted() {
      this.computeHeight()
      this.getReportDetail()
	  this.getCartList()
    },
   
    methods:{

    // 获取报告详情
    getReportDetail(){
	    	let that =this
	      this.axios({
	                  method: 'post',
	                  url:"index/getCountInfo",
	                  data:{
							member_id:this.$store.state.member_id,
							count_id:this.$route.params.id
	                  }
	                }).then(res=>{

			  if(res.data.count_info.head=="/static/admin/images/default_headimg.jpg"){
				  res.data.count_info.head = "../assets/tab-bar/indexme.png"
			  }
		   let date = new Date(res.data.count_info.create_date * 1000)
		   let year = (date.getFullYear()).toString()
		   let month = (date.getMonth() + 1).toString()
		   let day = date.getDate().toString()
		          if (month.length < 2) {
		            month = "0" + month.toString()
		          }
		          if (day.length < 2) {
		            day = "0" + day.toString()
		          }
		          res.data.count_info.create_date = year + month + day
          this.reportInfo = res.data.count_info
          this.products = res.data.goods_list
          	
	      })
	    },
	  // 做问卷
   toQuestions(){
     console.log("做问卷")
      this.$router.push({name: 'beforeQuestion'})
     },
	// 获取橘袋列表
	getCartList(){
		let that  = this
		this.axios({
				   method: 'post',
				   url:"Allcart/getCartList",
				   data:{
					  member_id:this.$store.state.member_id 
					}
			 }).then(res=>{
				 that.cartNum = res.data.cart_list.length
			})
	},
   //加入购物车
	addCart(){
		this.$refs.edit.getCountDetail(this.$route.params.id,6)
	}, 
	toBuy(){
		this.$refs.edit.getCountDetail(this.$route.params.id,7)
	},
	toCart(){
		this.$router.push({name: 'cart'})  
	},
	toIndex(){
		this.$router.push({name: 'Report'}) 
	},
  // 获取屏幕高
    computeHeight: function () {
      let  _winHeight = document.body.clientHeight
      let _winWidth = document.body.clientWidth;
      if(_winWidth>540){
        _winWidth = 540
      }
      console.log(_winHeight,_winWidth)
      let _teacherSay = _winHeight * 0.76 - (344 + 40 + 58 + 10 +88) / 750 * _winWidth
      console.log(_teacherSay)
      this.teacherSay = _teacherSay
     
    }, 

  }
}
</script>
<style>
#reportDetail{
  background:rgba(244,242,240,1);
  width: 7.5rem;
  height: 100vh;
  position:relative;
  margin: 0 auto;
}
.report-title {
    font-size: 0.42rem;
    font-weight: bold;
    text-align: center;
    padding: 0.94rem 0 0.64rem 0;
}
.container{
  width: 100%;
}
.report {
    width: 6.12rem;
    height: 76vh;
    background: #fff;
    border-radius: 0.1rem;
    text-align: center;
    /* box-shadow:0px 0px 20px 0px rgba(237,235,233,0.6); */
    position: relative;
}
.report:before {
    position: absolute;
    z-index: -1;
    content: "";
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(220,207,191,1);
    border-radius: 10px;
    opacity: 0.38;
    filter: blur(10px);
}
.reportTitle{
  padding-left: 0.6rem;
  height: 12.5vh;
 position: relative;
}
.reportTitleBox{
  display: flex;
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
}
.reportTitleLeft{
  width: 3.92rem;
  height: 1rem;
  text-align: left;
}
.reportTitleRight{
  height: 1rem;
  width: 1rem;
  border-radius: 1rem;
  overflow: hidden;
}
.reportTitleRight img{
  height: 100%;
  width: 100%;
  display: block;
}
.date {
  height:0.41rem;
  font-size:0.28rem;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(194,94,77,1);
  line-height:0.4rem;

}
.report .name {
  height:0.8rem;
  line-height: 0.8rem;
  font-size:0.38rem;
  font-family:SourceHanSansCN-Bold;
  font-weight:bold;
  color:rgba(20,20,20,1);
}
.reportContent{
  text-align: left;
  height: 30vh;
  box-sizing: border-box;
  position: relative;
}
.reportContentBox{
   position: absolute;
    left: 0;
    top: 50%;
    transform: translate(0,-50%);
    padding:0 0.6rem;
}
.report .reportContent .text {
    color: #505050;
    line-height: 0.6rem;
    margin-bottom: 0.2rem;
}
.report .reportContentBox .tags {
    display: flex;
    margin: 0 auto;
    box-sizing: border-box;
    flex-wrap: wrap;
    
}
.report .tags>div {
    width: 0.5rem;
    margin-right: 0.3rem;
    color: #141414;
    font-size: 0.24rem;
    text-align: center;
    margin-bottom: 0.2rem;
}
.report .tags img {
    width: 0.4rem;
    height: 0.4rem;
    margin: 0 auto 0.1rem auto;
}
.report .tags2 {
   /* display: flex; */
    height: 19vh;
    margin: 0 auto;
    /* justify-content: flex-start; */
    /* flex-wrap: wrap; */
    box-sizing: border-box;
 
}
.report .tags2 .tags2box {
  width: 1rem;
    color: #141414;
    font-size: 0.28rem;
    text-align: center;
    margin-bottom:0.35rem;
    display: inline-block;
}
.report .tags2 img {
    width: 0.5rem;
    height: 0.5rem;
    margin: 0 auto 0.1rem auto;
}
.report .attrs {
    width: 5.6rem;
    height: 16vh;
    box-sizing: border-box;
    margin: 0 auto;
    border-top: 1px solid #F2F4F8;
    border-bottom: 1px solid #F2F4F8;
    
    display: flex;
    justify-content: center;
}
.report .attrs .item {
     width: 1.8rem;
    height: 1rem;
    margin: auto;
    /* border-right: 3rpx solid rgba(80, 80, 80,0.15); */
}
.report .attrs .item:last-child {
    border: none;
}
.report .attrs .item div:first-child {
    color: #333;
    font-weight: bold;
    font-size: 0.3rem;
    margin-top: 0.11rem;
    margin-bottom: 0.1rem;
}
.report .attrs .item div:last-child {
    font-size: 0.24rem;
    color: #9B9B9B;
}

.product-tabs {
    display: flex;
    margin-bottom: 0.5rem;
    background: #fff;
    overflow: scroll;
    height: 1.22rem;
}
.product-tabs.product-tabs-fixed {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    z-index: 5;
    padding-bottom: 0.2rem;
    box-shadow: 0px 10px 20px #ddd;
}
.product-tabs .item {
    position: relative;
    width: 1.1rem;
    height: 1.1rem;
    margin-left: 0.2rem;
    flex-shrink: 0;
}
.product-tabs .item img.thumb {
    width: 100%;
    height: 100%;
    position: relative;
}
.product-tabs .item .number {
    position: absolute;
    right: 0.1rem;
    bottom: 0.1rem;
    font-size: 0.28rem;
    font-weight: bold;
}
.product-tabs .item.active .border {
    position: absolute;
    left: 0;
    top: 0;
    width: 1.1rem;
    height: 1.22rem;
    z-index: 2;
}

.footer-bar {
    display: none;
}
.report-footer-bar {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 16vh;
    display: flex;
    justify-content: space-between;
}
.report-footer-bar-null{
    position: fixed;
    left: 50%;
    bottom: 0;
    width: 7.5rem;
    transform: translate(-50%, 0); 
    box-sizing: border-box;
    height: 2rem;
    display: flex;
    padding: 0 0.4rem;
    align-items: center;
    justify-content: space-around;
}
.report-footer-bar .app-btn {
    width: 4.15rem;
    letter-spacing:0.05rem;
    height: 1rem;
    line-height: 1rem;
    text-align: center;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top:0;
    margin: auto;
}
.report-footer-bar-null .app-btn {
    width:3rem;
    letter-spacing:0.05rem;
    height: 1rem;
    line-height: 1rem;
    text-align: center;

}

.reportBox{
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  background:rgba(244,242,240,1);
  /* border-top:2rpx solid rgba(244, 242, 240, 1); */
}
.swiper{
  width:100%; 
  height:78%;
  overflow: hidden;
}
.content{
  font-size: 16px;
  color: #333;
  padding: 0.20rem 0.4rem;
}


.swiperitem{
  
  width: 6.12rem;
  height:100%;
}
.box{             
  width: 6.12rem;
  height:92%;
  display: inline-block;
  
  box-sizing: border-box;
  box-shadow:0px 0px 20px 0px rgba(185,199,187,0.6); 
  overflow: hidden;
  border-radius: 0.1rem;
  position: relative;
  background-color: #fff;
}
.kong .box{
  margin: 0.4rem auto 0;
  display: block;
}

/* 圆点样式 */
.dots{
   position: fixed;
  left: 0;
  right: 0;
  bottom:16vh;
  display: flex;
  justify-content: center;
}
.dots .dot{
  margin: 0 0.08rem;
  width: 0.11rem;
  height: 0.11rem;
  background:rgba(163,174,165,1);
  border-radius: 0.2rem;
  transition: all .6s;
}
.dots .dot.active{
  border-radius: 0.2rem;
  background:rgba(255,255,255,1);
}

.huadong{
  width: 100%;
  /* position: absolute; */
  bottom: 0;
  left: 0;
  height: 12vh;
  text-align: center;
  font-size:0.24rem;
  font-family:SourceHanSansCN-Normal;
  font-weight:400;
  color:rgba(80,80,80,1);
  line-height:0.32rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.productImg{
  width: 6.12rem;
  height: 3.44rem;
  margin-bottom: 0.4rem;
}
.productImgBox{
  width: 6.12rem;
  height: 3.44rem;
  background:#fff; 
  background-size:100% auto;
  background-repeat:no-repeat;
  background-position:top;
}
.productImg img{
  width: 6.12rem;
  height: 3.44rem;
}
.productImgTxt{
  width: 1.6rem;
  height: 0.5rem;
  text-align: center;
  line-height: 0.5rem;
  float: right;
  color:rgba(255, 255, 255, 1);
  background-color: rgba(183, 137, 117, 1);
  font-size: 0.22rem;
  font-weight: 400;
  border-radius: 0 0 0 0.1rem;  
}
.productcont{
  width: 6.12rem;
  height: 5.76rem;
  position: relative;
}
.productcontTxt{
  width: 6.12rem;
  height: 0.58rem;
  margin-bottom: 0.1rem;
  padding-right:0.4rem;
  box-sizing: border-box; 
  display: flex;
  justify-content: space-between;
}
.productcontName{
  height: 0.58rem;
  line-height: 0.58rem;
  text-align: left;
  padding-left: 0.4rem;
  font-size: 0.4rem;
  color: rgba(20, 20, 20, 1);
  letter-spacing: 0rem;
  font-weight: 800;
}
.productcontPage{
  overflow-y:auto;
}
.productcontUse{
  height: 0.37rem;
  line-height: 0.37rem;
  text-align: left;
  margin-left: 0.4rem;
  font-size: 0.26rem;
  color: rgba(114, 113, 113, 1);
  margin-bottom: 0.2rem;
}
.productcontImg{
  height:0.32rem;
  padding-top:0.13rem;
  display: flex;
}
.productcontImg img{
  height: 0.32rem;
  width: 0.32rem;
  margin-left: 0.08rem;
}
.productcontTeacher{
  padding: 0.2rem 0;
  width: 6.12rem;
  display: flex;
}
.productcontTeacherBox{
  width: 1.2rem;
  height: 2.1rem;
  margin-left: 0.2rem;
}
.productcontTeacherImg{
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 0.8rem;
  margin: 0 auto;
}
.productcontTeacherImg img{
  width: 0.8rem;
  height: 0.8rem;
}
.productcontTeacherName{
  width: 1.2rem;
  margin-top: 0.13rem;
  text-align: center;
  font-size: 0.22rem;
  color: rgba(114, 113, 113, 1);
}
.productcontTeacherTxt{
  width: 4.2rem;
  padding: 0.2rem;
  box-sizing: border-box;
  font-size: 0.24rem;
  background-color: #fff;
  margin-right: 0.4rem;
  text-align: left;
  box-shadow:0px 2px 20px 0px rgba(114,113,113,0.15);
  border-radius: 0.15rem;
  margin-bottom: 0.8rem;
}
.toDeatil{
  width: 6.12rem;
  /* box-sizing: border-box; */
  height: 0.88rem;
  line-height: 0.88rem;
  /* text-align: center; */
  /* color: rgba(102, 102, 102, 1); */
  /*color:#C25E4D;*/
  font-size: 0.32rem;
  letter-spacing: 0.02rem;
  font-family: PingFangSC-Medium;
  font-weight: 400;
  /*border-top: 1rpx solid RGBA(236, 237, 235, 0.6);*/
  background: rgba(183, 137, 117, 1); 
  text-align: center; 
  color: #fff;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 9;
  /* background: #fff; */
  /* background:rgba(183,137,117,1); */
  box-shadow:0px 0px 20px 0px rgba(114,113,113,0.1);
}
.toDeatil img{
  height: 0.24rem;
  width: 0.14rem;
  margin-left: 0.16rem;
  display: inline-block;
  position: relative;
  top:0.02rem;
  /* position: absolute; */
  /* top:50%; */
  /* margin-top: -10rpx; */
  /* right: 200rpx; */
  /* transform:rotate(180deg); */
  /* opacity: 0.5; */
}
.sanjiao{
  width: 0.3rem;
  height:0.3rem;
  /*padding-top: 0.2rem;*/
  position: relative;
  right: -0.02rem;
 
}
.sanjiao img{
  width:0.3rem;
  height:0.3rem;
  position: absolute;
  right:0;
}
.docterTitle{
  height:12vh;
  text-align: center;
  line-height: 12vh;
  color: rgba(20, 20, 20, 1);
  letter-spacing: 0.02rem;
  font-size: 0.42rem;
  font-weight: 700;
}
.docterCont{
  height: 60vh;
  width: 6.12rem;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.docterCont::-webkit-scrollbar {display:none}
.docterCont img{
  width: 6.12rem;
}

.productspec{
  min-height: 0.38rem;
  padding: 0 0.4rem 0.2rem 0.4rem;
  display: flex;
  flex-wrap: wrap;
}
.productspec .itemspec{
height: 0.32rem;
line-height: 0.32rem;
color: rgba(153, 153, 153, 1);

font-size: 0.24rem;
padding: 0 0.2rem;
border-radius: 0.11rem;
border: 0.01rem solid rgba(194, 201, 191, 1);
margin-right: 0.2rem;
margin-bottom: 0.1rem;
}
.productcontTeacherTxt1{
  color: rgba(74, 74, 74, 1);
  font-size: 0.28rem;
  font-weight: 700;
  min-height: 0.36rem;
  line-height: 0.36rem;
  
}
.productcontTeacherTxt2{
  color: rgb(134, 134, 134);
  padding: 0.2rem 0;
  font-size:0.26rem;
  line-height:0.4rem;
}
.productcontTeacherTxt3{
  height: 0.02rem;
  background-color: rgba(224, 227, 222, 0.7);
  margin-bottom: 0.2rem;
}


.movewin{
  width: 240rpx;
  height: 80rpx;
  line-height: 80rpx;
  background:rgba(183,137,117,1);
  border-radius:40rpx;
  position: fixed;
  text-align: center;
  z-index: 999;
  font-size:30rpx;
  font-family:PingFangSC-Semibold;
  font-weight:600;
  color:rgba(255,255,255,1);
}

.toDeatilBtn{
  width: 240rpx;
  height: 80rpx;
  line-height: 80rpx;
  background:rgba(183,137,117,1);
  border-radius:40rpx;
  text-align: center;
  font-size:30rpx;
  font-family:PingFangSC-Semibold;
  font-weight:600;
  color:rgba(255,255,255,1);

  /* position: absolute;
  top:76vh;
  right: 50rpx;
  z-index:9999; */
   /*top:-100rpx;
  left: 350rpx; */
}
.toDeatilBtn1{
  
  height: 60rpx;
  line-height: 60rpx;
  border-radius:30rpx;
  text-align: center;
  width: 200rpx;
  background:rgba(183,137,117,1);
   color:rgba(255,255,255,1);
}
.reportCenter{
  height: 61.5vh;
  padding: 0 60rpx;
  position: relative; 
}
.reportCenterBox{
  width:492rpx;
  position: absolute;
    top: 40%;
    transform: translate(0,-50%);
}
.reportCenterTop{
  height: 100rpx;
  display: flex;
}
.reportCenterTopImg{
  height: 100rpx;
  width: 100rpx;
  border-radius: 100rpx;
  overflow: hidden;
}
.reportCenterTopImg img{
  height: 100rpx;
  width: 100rpx;
  display: block;
}
.reportCenterTopTxt{
  padding: 16rpx 17rpx 10rpx;
  text-align: left;
}
.reportCenterTopTxtName{
  height:38rpx;
  font-size:27rpx;
  font-family:PingFangSC-Medium;
  font-weight:500;
  color:rgba(20,20,20,1);
  line-height:38rpx;
  margin-bottom: 8rpx;
}
.reportCenterTopTxtDr{
  height:28rpx;
  font-size:20rpx;
  font-family:PingFangSC-Medium;
  font-weight:500;
  color:rgba(114,113,113,1);
  line-height:28rpx;
}
.reportCenterBottom{
  position: relative;
  font-size:25rpx;
  font-family:SourceHanSansCN-Normal;
  font-weight:400;
  color:rgba(20,20,20,1);
  line-height:45rpx;
  letter-spacing:1rpx;
  text-align: left;
  background:rgba(255,255,255,1);
  border:1rpx solid rgba(195,195,195,0.78);
  padding: 33rpx;
  margin-top:50rpx;
  overflow: visible;
  border-radius: 20rpx;
}
.reportCenterBottom img{
  width: 26rpx;
  height: 25rpx;
  position: absolute;
  top:-22rpx;
  left:30rpx;
}
.nullpick{
   background:  #ddd  !important;
   border: 1rpx solid #ddd  !important;
   color: #fff !important;
}


.whiteBtn{
    width:2.8rem;
    height:0.88rem;
    /* background:rgba(124, 2, 0, 1);
    border:3rpx solid rgba(241,221,176,1); */
    background:rgb(255, 255, 255);
    border-radius:0.49rem;
    font-size:0.32rem;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    /* color:rgba(241,221,176,1); */
    color:rgba(194,94,77,1);
    line-height:0.88rem;
    box-shadow:0 0.05rem 0.15rem 0 rgba(194,94,77,0.25);
    text-align: center;
}
.reBtn{
  width:2.8rem;
  height:0.88rem;
  /* background:rgba(241, 221, 176, 1); */
  background:rgba(194,94,77,1);
  box-shadow:0 0.05rem 0.11rem -0.02rem rgba(194,94,77,0.4);
  border-radius:0.43rem;
  font-size:0.32rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  /* color:rgba(124, 2, 0, 1); */
  color:rgba(255,255,255,1);
  line-height:0.88rem;
  text-align: center;
  position: relative;
  overflow: visible;
}
.btnTitle{
  width: 1.16rem;
  height: 0.36rem;
  background-color: #fff;
  position: absolute;
  top:-0.18rem;
  right: 0.3rem;
  border-radius: 0.18rem;
  line-height: 0.36rem;
  color:rgba(124, 2, 0, 1);
  font-size: 0.2rem;
  font-weight: 500;
  letter-spacing: 0.01rem;
}
.cartDiv{
	width:7.5rem;
	height: 1.38rem;
	right: 0;
	bottom:10vh;
	z-index: 100;
	position: fixed;
	overflow: hidden;
	left:50%;
	transform: translate(-50%,0); 
}
 .cartNumBox{
  width: 1.38rem;
  height: 1.38rem;
  position: absolute;
  right: -1.38rem;
  top:0;
  transition: all 0.8s;
  z-index: 100;
}
.cartBoxShow{
  right: 0.4rem;
}
.cartDiv .cartNumImg{
  width: 1.38rem;
  height: 1.38rem;
  display: block;
}
.cartDiv .cartNum{
  position: absolute;
  width: 0.36rem;
  height: 0.36rem;
  border-radius: 0.34rem;
  color: #fff;
  right: 0.3rem;
  top:0.32rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:500;
  text-align: center;
  font-size: 0.22rem;
  line-height: 0.36rem;
  background-color: #C45E4C;
}

.toggleTeacher{
  position: fixed;
  top:0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
}
.toggleTeacherMask{
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0,0.7)
}
.toggleTeacherBox{
  width: 70vw;
  height: 3rem;
  background-color: #fff;
  position: absolute;
  top:25vh;
  left: 15vw;
  border-radius:0.1rem;
}
.toggleTeacherTitle{
  padding: 0.6rem 0.3rem 0.2rem;
  height: 2.12rem;
  box-sizing: border-box;
  font-size: 0.32rem;
  text-align: justify;
}
.toggleTeacherBtn{
  display: flex;
  height: 0.88rem;
  line-height: 0.88rem;
  text-align: center;
  border-top: 0.01rem solid #d4d4d4;
}
.toggleTeacherBtn1{
  height: 0.88rem;
  width: 35vw;
  font-size: 0.32rem;
  border-right: 0.01rem solid #d4d4d4;
}
.toggleTeacherBtn2{
  height: 0.88rem;
  background: #fff;
  font-size: 0.32rem;
  width: 35vw;
  color: #C25E4D;
}
.toggleTeacherBtn button:after{
  border:0;
}

.productcontPage::-webkit-scrollbar {display:none}
</style>